<template>
  <div class="bg-white rounded-xl shadow-md p-4 flex flex-col items-center">
    <h3 class="text-sm font-semibold text-gray-700 mb-3 text-center leading-tight">
      {{ title }}
    </h3>

    <!-- Empty state quand toutes les données sont à 0 -->
    <div
      v-if="isEmpty"
      class="flex flex-col items-center justify-center py-8 w-full"
    >
      <div
        class="w-32 h-32 rounded-full border-8 border-gray-100 flex items-center justify-center mb-4"
      >
        <i class="pi pi-chart-pie text-4xl text-gray-300"></i>
      </div>
      <p class="text-sm text-gray-400 text-center">
        {{ $t("user_progression.stats.no_data") }}
      </p>
    </div>

    <!-- Chart normal -->
    <Chart
      v-else
      type="doughnut"
      :data="chartData"
      :options="chartOptions"
      class="w-full max-w-[16rem]"
    />
  </div>
</template>

<script setup>
import { computed } from "vue";
import Chart from "primevue/chart";
import { defineProps } from "vue";

const props = defineProps({
  title: {
    type: String,
    default: "",
  },
  labels: {
    type: Array,
    required: true,
  },
  data: {
    type: Array,
    required: true,
  },
  colors: {
    type: Array,
    default: () => ["#66BB6A", "#FFA726", "#EF5350"],
  },
});

const isEmpty = computed(() => {
  const total = props.data.reduce((acc, v) => acc + (Number(v) || 0), 0);
  return total === 0;
});

const chartData = computed(() => ({
  labels: props.labels,
  datasets: [
    {
      data: props.data,
      backgroundColor: props.colors,
      hoverBackgroundColor: props.colors.map((c) => c + "CC"),
      borderWidth: 0,
    },
  ],
}));

const chartOptions = computed(() => ({
  cutout: "60%",
  responsive: true,
  maintainAspectRatio: true,
  plugins: {
    legend: {
      position: "bottom",
      labels: {
        usePointStyle: true,
        pointStyle: "circle",
        boxWidth: 8,
        boxHeight: 8,
        padding: 16,
        font: { size: 12 },
      },
    },
  },
}));
</script>
